import { createSlice } from '@reduxjs/toolkit';
import { portalApi } from '../api/portalApi';

// Re-export RTK Query hook for direct component use
export { useGetPumpUpdateDataQuery } from '../api/portalApi';

/**
 * Backward-compatible thunk wrapper.
 */
export const fetchPumpUpdateData = (PumpParentID) => (dispatch) => {
  return dispatch(
    portalApi.endpoints.getPumpUpdateData.initiate(PumpParentID, {
      forceRefetch: true,
    })
  );
};

const hasPumpApiPingSlice = createSlice({
  name: 'hasPumpApiPing',
  initialState: {
    pumpData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ── RTK Query: getPumpUpdateData ────────────────────────────────────
      .addMatcher(
        portalApi.endpoints.getPumpUpdateData.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        portalApi.endpoints.getPumpUpdateData.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.pumpData = action.payload;
        }
      )
      .addMatcher(
        portalApi.endpoints.getPumpUpdateData.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message ?? 'Failed to fetch pump update data';
        }
      );
  },
});

// Export the reducer to be added to the store
export default hasPumpApiPingSlice.reducer;
